import { takeLatest, call, put, all } from 'redux-saga/effects';

// SERVICES
import { ApiResponse, postApi } from 'services/_api';
import { CHANNEL, PATH_DETRAN_CNH } from 'services/_path';

// TYPES
import { ReducerAction } from 'store/modules/types';
import { Types, IRequestEnderecos } from './types';

// ACTIONS
import { consultaEnderecosSuccess, consultaEnderecosFailure } from './actions';

function* consultaEnderecos(request: ReducerAction) {
	const { payload }: { payload: IRequestEnderecos } = request;

	const response: ApiResponse = yield call(
		postApi,
		PATH_DETRAN_CNH,
		`condutor/${CHANNEL}/enderecos`,
		payload,
	);

	if (response.status === 200) {
		yield put(consultaEnderecosSuccess(response));
	} else if (response.error) {
		yield put(consultaEnderecosFailure());
	}
}

export default all([takeLatest(Types.CONSULTA_ENDERECOS, consultaEnderecos)]);
